import { makeStyles } from "@material-ui/core/styles";
import { green, red } from "@material-ui/core/colors";

// D8.15.1 — Estilos.
export const useStyles = makeStyles(theme => ({
  // Título
  titleRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    paddingBottom: 0,
  },
  titleIcon: {
    color: theme.palette.primary.main,
    fontSize: 22,
  },

  // Banner contacto
  contactBanner: {
    width: "100%",
    background: theme.mode === "dark"
      ? "rgba(59,130,246,0.15)"
      : "rgba(59,130,246,0.07)",
    borderRadius: 8,
    padding: "6px 14px",
    marginTop: 6,
    marginBottom: 2,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    boxSizing: "border-box",
  },
  contactDot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: theme.palette.primary.main,
    flexShrink: 0,
  },
  contactText: {
    flex: 1,
    minWidth: 0,
    fontSize: "0.875rem",
    fontWeight: 700,
    color: theme.palette.primary.main,
    wordBreak: "break-word",
    whiteSpace: "normal",
    overflow: "visible",
  },

  // Tabs
  mainTabs: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    marginBottom: theme.spacing(1.5),
    minHeight: 40,
    "& .MuiTab-root": { minHeight: 40, padding: "6px 12px" },
    "& .MuiTab-wrapper": { flexDirection: "row", gap: 4 },
  },

  // Etiquetas de sección
  sectionLabel: {
    fontSize: "0.68rem",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.07em",
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(0.75),
    marginTop: theme.spacing(1.5),
  },

  // Área de mensaje
  messageWrapper: {
    position: "relative",
  },
  messageActions: {
    position: "absolute",
    bottom: 6,
    right: 6,
    display: "flex",
    alignItems: "center",
    gap: 2,
    background: theme.mode === "dark" ? "rgba(31,41,55,0.85)" : "rgba(255,255,255,0.85)",
    borderRadius: 4,
    padding: "1px 2px",
  },
  msgActionBtn: {
    padding: 4,
    color: theme.palette.text.secondary,
    "&:hover": { color: theme.palette.primary.main },
  },
  uploadInput: { display: "none" },

  // Botón principal
  btnWrapper: { position: "relative" },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -11,
    marginLeft: -11,
  },

  // Historial
  historyEmpty: {
    textAlign: "center",
    color: theme.palette.text.secondary,
    padding: theme.spacing(4, 0),
  },
  historyItem: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8,
    marginBottom: theme.spacing(1),
    padding: theme.spacing(0.75, 1.5),
  },
  historyBody: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: 260,
    fontSize: "0.875rem",
  },
  historyMeta: {
    fontSize: "0.72rem",
    color: theme.palette.text.secondary,
    marginTop: 2,
  },
  statusChip: {
    height: 18,
    fontSize: "0.62rem",
    fontWeight: 700,
  },
  cancelBtn: {
    color: red[400],
    padding: 4,
  },
}));
